{
  "title": "Commune",
  "source": "Player's Handbook",
  "levelAndSchool": "5th-level divination (ritual)",
  "level": 5,
  "castingTime": "1 minute",
  "range": "Self",
  "components": "V, S, M (incense and a vial of holy or unholy water)",
  "duration": "1 minute",
  "description": [
    "You contact your deity or a divine proxy and ask up to three questions that can be answered with a yes or no. You must ask your questions before the spell ends. You receive a correct answer for each question.",
    "Divine beings aren’t necessarily omniscient, so you might receive “unclear” as an answer if a question pertains to information that lies beyond the deity’s knowledge. In a case where a one-word answer could be misleading or contrary to the deity’s interests, the DM might offer a short phrase as an answer instead.",
    "If you cast the spell two or more times before finishing your next long rest, there is a cumulative 25 percent chance for each casting after the first that you get no answer. The DM makes this roll in secret."
  ],
  "spellLists": ["cleric"]
}
